import {
  faCheck,
  faEdit,
  faEye,
  faEyeSlash,
  faFile,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { downloadExcel } from "react-export-table-to-excel";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddCon from "./addCon";
import AddContact from "./addContact";
import "./app.css";
import Conf from "./conf";
import { secretKey } from "./data";
import LeadDetail from "./leadDetail";
import LeadSendDetail from "./leadSendDetails";
import Loading from "./loading.js";
import MultiSelect from "./multiSelect.js";
import ShowNote from "./showNote";
import Statistics from "./statistics";

const MySwal = withReactContent(Swal2);

const Database = (props) => {
  const [querySource, setQuerySource] = useState("");
  const [queryStatus, setQueryStatus] = useState("");
  const [queryUser, setQueryUser] = useState(
    props.user.role === "admin" ? "all" : props.user.id
  );
  const [showConf, setShowConf] = useState(false);
  const [showStats, setShowStats] = useState(false);

  const [loading, setLoading] = useState(true);
  const [editModeName, setEditModeName] = useState(false);
  const [editName, setEditName] = useState("");
  const [page, setPage] = useState("1");
  const [perPage, setPerPage] = useState("200");
  const [editNameId, setEditNameId] = useState("");
  const [editModePhone, setEditModePhone] = useState(false);
  const [editPhone, setEditPhone] = useState("");
  const [editPhoneId, setEditPhoneId] = useState("");
  const [editModeMail, setEditModeMail] = useState(false);
  const [editMail, setEditMail] = useState("");
  const [editMailId, setEditMailId] = useState("");
  const [editModeNote, setEditModeNote] = useState(false);
  const [editNote, setEditNote] = useState("");
  const [editNoteId, setEditNoteId] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [showNoteSource, setShowNoteSource] = useState(false);
  const [showNoteSourceId, setShowNoteSourceId] = useState(false);
  const [showNote, setShowNote] = useState(false);
  const [showNoteB, setShowNoteB] = useState(false);
  const [showNoteId, setShowNoteId] = useState(false);
  const [expandId, setExpandId] = useState(false);
  const [leads, setLeads] = useState([]);
  const [leadsOri, setLeadsOri] = useState([]);
  const [users, setUsers] = useState([]);
  const [usersFull, setUsersFull] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [sources, setSources] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [leadDetail, setLeadDetail] = useState([]);
  const [showLeadDetail, setShowLeadDetail] = useState(false);

  const [filterText, setFilterText] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [selectedOptionsStatus, setSelectedOptionsStatus] = useState([]);
  const [isHoveringStatus, setIsHoveringStatus] = useState(false);
  const [filterSource, setFilterSource] = useState("");
  const [selectedOptionsSource, setSelectedOptionsSource] = useState([]);
  const [isHoveringSource, setIsHoveringSource] = useState(false);
  const [filterUser, setFilterUser] = useState("");
  const [selectedOptionsUser, setSelectedOptionsUser] = useState([]);
  const [isHoveringUser, setIsHoveringUser] = useState(false);
  const [filterCompany, setFilterCompany] = useState("");
  const [selectedOptionsCompany, setSelectedOptionsCompany] = useState([]);
  const [isHoveringCompany, setIsHoveringCompany] = useState(false);
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");
  const [filterDate, setFilterDate] = useState(false);
  const [filterDateTalkFrom, setFilterDateTalkFrom] = useState("");
  const [filterDateTalkTo, setFilterDateTalkTo] = useState("");
  const [filterDateTalk, setFilterDateTalk] = useState(false);
  const [filterDateStatusFrom, setFilterDateStatusFrom] = useState("");
  const [filterDateStatusTo, setFilterDateStatusTo] = useState("");
  const [filterDateStatus, setFilterDateStatus] = useState(false);
  const [sort, setSort] = useState("dateDesc");
  const [noteMode, setNoteMode] = useState("note");
  const [con, setCon] = useState("");
  const [checkLead, setCheckLead] = useState([]);
  const [showCheckCon, setShowCheckCon] = useState(false);
  const [showAddContact, setShowAddContact] = useState(false);
  const [addContactLeadId, setAddContactLeadId] = useState("");
  const [chooseLeads, setChooseLeads] = useState([]);
  const [chooseLeadsFlag, setChooseLeadsFlag] = useState(false);
  const [showSendReportId, setShowSendReportId] = useState("");
  const [showSendReport, setShowSendReport] = useState(false);
  const [clikcs, setClicks] = useState([]);

  const closeLeadDetail = () => {
    setShowLeadDetail(false);
    getData();
  };

  const closeCheckCon = () => {
    setShowCheckCon(false);
    setCon("");
    setCheckLead([]);
    getData();
  };

  const fetchLeads = async () => {
    var body = {
      user: queryUser,
      source: querySource,
      status: queryStatus,
    };

    await fetch("https://apisellcrm.ftpeople.pl/getLeads", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var dataSort = data
          .sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          })
          .sort(function (a, b) {
            return +a.statusPoz - +b.statusPoz;
          });
        setLeads(dataSort);
        setLeadsOri(dataSort);
        handleFilterChange("", "", data);
        fetchClicks();
      })
      .catch((error) => {});
  };

  const fetchClicks = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getClicks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClicks(data);
        fetchUsersList();
      })
      .catch((error) => {});
  };

  const fetchUsersList = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getUsersList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        fetchUsersFull();
      })
      .catch((error) => {});
  };

  const fetchUsersFull = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getUsersListAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersFull(data);
        fetchStatuses();
      })
      .catch((error) => {});
  };

  const fetchStatuses = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getStatuses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setStatuses(data);
        fetchSources();
      })
      .catch((error) => {});
  };

  const fetchSources = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getLeadSources", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSources(data);
        fetchCompanies();
      })
      .catch((error) => {});
  };

  const fetchCompanies = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getCompanies", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setCompanies(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchLeads();
  };

  const getDataConf = () => {
    setLoading(true);
    fetchLeads();
  };

  useEffect(() => {
    getData();
  }, []);

  const showLeadDetailBox = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setLeadDetail(leads.filter((lead) => +lead.id === +value)[0]);
    setShowLeadDetail(true);
  };

  const showNoteBox = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setLeadDetail(leads.filter((lead) => +lead.id === +value)[0]);
    setNoteMode("note");
    setShowNote(true);
  };

  const showNoteSourceBox = (e) => {
    e.preventDefault();

    var value = e.currentTarget.attributes.value.value;
    setLeadDetail(leads.filter((lead) => +lead.id === +value)[0]);
    setNoteMode("source");
    setShowNoteB(true);
  };

  const expandLead = (e) => {
    e.preventDefault();

    var value = e.currentTarget.attributes.value.value;
    if (+expandId === +value) {
      setExpandId(0);
    } else {
      setExpandId(value);
    }
  };

  const fetchEditLead = async (id, field, value) => {
    var body = { id: id, field: field, value: value };

    await fetch("https://apisellcrm.ftpeople.pl/editLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const editLeadField = (e) => {
    var id = e.currentTarget.value;
    var field = e.currentTarget.id;

    var val = "";
    if (field === "name") {
      val = editName;
    } else if (field === "phone") {
      val = editPhone;
    } else if (field === "mail") {
      val = editMail;
    } else if (field === "statusNote") {
      val = editNote;
    }

    fetchEditLead(id, field, val);

    setEditModeName(false);
    setEditModePhone(false);
    setEditModeMail(false);
    setEditModeNote(false);

    setEditNameId("");
    setEditName("");

    setEditPhoneId("");
    setEditPhone("");

    setEditMailId("");
    setEditMail("");

    setEditNoteId("");
    setEditNote("");
  };

  const handleEditModeName = (e) => {
    setEditModeName(!editModeName);
    setEditNameId(e.currentTarget.value);
    setEditName(
      leadsOri.filter((el) => +el.id === +e.currentTarget.value)[0].name
    );
    setEditModePhone(false);
    setEditModeNote(false);
    setEditModeMail(false);
  };

  const handleEditModePhone = (e) => {
    setEditModePhone(!editModePhone);
    setEditPhoneId(e.currentTarget.value);
    setEditPhone(
      leadsOri.filter((el) => +el.id === +e.currentTarget.value)[0].phone
    );
    setEditModeName(false);
    setEditModeMail(false);
    setEditModeNote(false);
  };

  const handleEditModeMail = (e) => {
    setEditModeMail(!editModeMail);
    setEditMailId(e.currentTarget.value);
    setEditMail(
      leadsOri.filter((el) => +el.id === +e.currentTarget.value)[0].mail
    );
    setEditModeName(false);
    setEditModePhone(false);
    setEditModeNote(false);
  };

  const handleEditModeNote = (e) => {
    setEditModeNote(!editModeNote);
    setEditNoteId(e.currentTarget.value);
    setEditNote(
      leadsOri.filter((el) => +el.id === +e.currentTarget.value)[0].statusNote
    );
    setEditModeName(false);
    setEditModePhone(false);
    setEditModeMail(false);
  };

  const editLead = (e) => {
    var id = e.currentTarget.value;
    var field = e.currentTarget.id;
    var valueP = e.currentTarget.attributes.fieldValue.value;

    MySwal.fire({
      title: "Zmiana",
      input: "text",
      inputValue: valueP,
      cancelButtonText: "Anuluj",
      inputLabel: "nowa wartość",
      showCancelButton: true,
      inputValidator: (value) => {
        fetchEditLead(id, field, value);
      },
    });
  };

  const handleShowNoteSource = (e) => {
    var id = e.currentTarget.value;
    var field = e.currentTarget.id;
    var valueP = e.currentTarget.attributes.fieldValue.value;

    setShowNoteSourceId(id);
    if (+id === +showNoteSourceId) {
      setShowNoteSource(!showNoteSource);
    } else {
      setShowNoteSource(true);
    }
  };

  const handleShowNote = (e) => {
    var id = e.currentTarget.value;
    var field = e.currentTarget.id;
    var valueP = e.currentTarget.attributes.fieldValue.value;

    setShowNoteId(id);
    if (+id === +showNoteId) {
      setShowNote(!showNote);
    } else {
      setShowNote(true);
    }
  };

  const editLeadDate = (e) => {
    setAddContactLeadId(e.currentTarget.value);
    setShowAddContact(true);
  };

  const closeAddContact = () => {
    setShowAddContact(false);
    getData();
  };

  const editLeadStatus = (e) => {
    var id = e.currentTarget.value;
    var field = e.currentTarget.id;

    var model = [];
    statuses.map((el) => {
      model[el.name] = el.name;
    });

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        fetchEditLead(id, field, result.value);
      }
    });
  };

  const editLeadSeller = (e) => {
    var id = e.currentTarget.value;
    var field = e.currentTarget.id;
    var company = e.currentTarget.attributes.fieldValue.value;

    console.log(company);

    var model = [];
    users
      .filter((el) => el.companies === company)
      .map((el) => {
        model[el.id] = el.name;
      });

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        fetchEditLead(id, field, result.value);
      }
    });
  };

  const fetchUncheckCon = async (id, con) => {
    var body = { id: id, con: con };

    await fetch("https://apisellcrm.ftpeople.pl/uncheckCon", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const fetchCheckCon = async (con, id) => {
    var body = {
      con: con,
      id: id,
      date: new Date(),
      time: new Date().toTimeString(),
    };

    await fetch("https://apisellcrm.ftpeople.pl/checkCon", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
    var id = id;
    var field = "lastTalkDate";

    var date =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate());

    fetchEditLead(id, field, date);
  };

  const handleCon1 = (e) => {
    var id = e.currentTarget.attributes.fieldID.value;
    var field = e.currentTarget.id;

    var lead = leads.filter((el) => +el.id === +id)[0];

    if (lead.con1 === "1" && lead.con2 !== "1") {
      fetchUncheckCon(id, field);
    } else if (lead.con1 === "1" && lead.con2 === "1") {
      return;
    } else {
      fetchCheckCon("con1", id);
    }
  };

  const handleCon2 = (e) => {
    var id = e.currentTarget.attributes.fieldID.value;
    var field = e.currentTarget.id;

    var lead = leads.filter((el) => +el.id === +id)[0];

    if (lead.con2 === "1" && lead.con3 !== "1") {
      fetchUncheckCon(id, field);
    } else if (lead.con2 === "1" && lead.con3 === "1") {
      return;
    } else {
      fetchCheckCon("con2", id);
    }
  };

  const handleCon3 = (e) => {
    var id = e.currentTarget.attributes.fieldID.value;
    var field = e.currentTarget.id;

    var lead = leads.filter((el) => +el.id === +id)[0];

    if (lead.con3 === "1" && lead.con4 !== "1") {
      fetchUncheckCon(id, field);
    } else if (lead.con3 === "1" && lead.con4 === "1") {
      return;
    } else {
      fetchCheckCon("con3", id);
    }
  };

  const handleCon4 = (e) => {
    var id = e.currentTarget.attributes.fieldID.value;
    var field = e.currentTarget.id;

    var lead = leads.filter((el) => +el.id === +id)[0];

    if (lead.con4 === "1" && lead.con5 !== "1") {
      fetchUncheckCon(id, field);
    } else if (lead.con4 === "1" && lead.con5 === "1") {
      return;
    } else {
      fetchCheckCon("con4", id);
    }
  };

  const handleCon5 = (e) => {
    var id = e.currentTarget.attributes.fieldID.value;
    var field = e.currentTarget.id;

    var lead = leads.filter((el) => +el.id === +id)[0];

    if (lead.con5 === "1") {
      fetchUncheckCon(id, field);
    } else {
      fetchCheckCon("con5", id);
    }
  };

  const getNValue = () => {
    if (+page === 1) {
      return 0;
    } else {
      return +page * +perPage - +perPage;
    }
  };

  const getValue = () => {
    if (+page === 1) {
      return 200;
    } else {
      return +page * +perPage + +perPage - +perPage;
    }
  };

  const sendLeadSMSMAIL_after = (e) => {
    var id = e.currentTarget.value;
    var field = e.currentTarget.id;

    var model = [];
    model["TCHF"] = "Twoje CHF";
    model["AWIB"] = "Anulujemy WIBOR";
    model["ODSKD"] = "Odzyskaj SKD";

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var brand = result.value;
        var mail = leadsOri.filter((el) => +el.id === +id)[0].mail;
        var phone = leadsOri.filter((el) => +el.id === +id)[0].phone;

        console.log(brand);
        console.log(mail);
        console.log(phone);

        var body = { mail: mail, company: brand };

        fetch("https://apisellcrm.ftpeople.pl/sendMail", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {})
          .catch((error) => {});

        var body2 = { phone: phone, company: brand };

        fetch("https://apisellcrm.ftpeople.pl/sendSms", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.text())
          .then((data) => {})
          .catch((error) => {});
      }
    });
  };

  const sendLeadToSendTemp = async (e) => {
    var body = { id: e.target.value };

    await fetch("https://apisellcrm.ftpeople.pl/sendToSendTemp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Przekazano",
          text: "do wysyłki",
        }).then(async (result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const leadsData2 = (
    <>
      <div style={{ width: "100%" }}>
        <p
          style={{
            textAlign: "left",
            margin: "0",
            fontSize: ".8vw",
            marginBottom: "1vh",
          }}
        >
          Liczba kontaktów: {leads.length} (prezentowane {perPage} na stronę)
        </p>
        {leads.slice(getNValue(), getValue()).map((lead, index) => (
          <>
            <div
              style={{
                backgroundColor:
                  statuses.filter((el2) => el2.name === lead.status).length > 0
                    ? statuses.filter((el2) => el2.name === lead.status)[0]
                        .color
                    : "",
                width: "100%",
                marginBottom: "1vh",
                border: "2px solid lightgray",
                borderRadius: "5px",
                minHeight: "5vh",
                display: "flex",
                alignItems: "start",
                flexWrap: "wrap",
                padding: "5px",
                fontSize: "1vw",
                gap: "5px",
              }}
            >
              <div
                style={{
                  width: "2%",
                  textAlign: "left",
                  padding: ".5%",
                  paddingRight: "5px",
                }}
              >
                <input
                  style={{ width: "15px", height: "15px", margin: "0" }}
                  className="checkInput"
                  type="checkbox"
                  value={lead.id}
                  onChange={(e) => {
                    var arr = [];

                    if (
                      chooseLeads.filter((q) => +q === +e.target.value).length >
                      0
                    ) {
                      chooseLeads.map((p) => {
                        if (+p !== +e.target.value) {
                          arr.push(p);
                        }
                      });
                    } else {
                      arr = chooseLeads;
                      arr.push(e.target.value);
                    }
                    if (arr.length > 0) {
                      setChooseLeadsFlag(true);
                    } else {
                      setChooseLeadsFlag(false);
                    }
                    setChooseLeads(arr);
                  }}
                />
              </div>
              <div
                style={{
                  width: "8%",
                  textAlign: "left",
                  padding: ".5%",
                  paddingRight: "5px",
                }}
              >
                <p style={{ fontWeight: "600", margin: "0", fontSize: ".7vw" }}>
                  Nazwa:
                </p>
                <div style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
                  <span style={{ width: "100%", minHeight: ".8vw" }}>
                    {editModeName && +editNameId === +lead.id ? (
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "80%" }}>
                          <input
                            type="text"
                            style={{
                              width: "100%",
                              height: "100%",
                              padding: "0px 10px",
                              boxSizing: "border-box",
                              fontSize: ".8vw",
                            }}
                            value={editName}
                            onChange={(e) => {
                              setEditName(e.target.value);
                            }}
                          />
                        </div>
                        <div style={{ width: "25%" }}>
                          <button
                            className="loginButtonLogin"
                            id={"name"}
                            value={lead.id}
                            fieldValue={editName}
                            style={{
                              margin: "0",
                              backgroundColor: "transparent",
                              color: "green",
                              border: "none",
                              width: "1%",
                              fontSize: ".6vw",
                              padding: "5px 5px",
                            }}
                            onClick={editLeadField}
                          >
                            <FontAwesomeIcon icon={faSave} />
                          </button>
                        </div>
                      </div>
                    ) : (
                      lead.name.substring(0, 30)
                    )}
                  </span>
                  <button
                    className="loginButtonLogin"
                    id={"name"}
                    value={lead.id}
                    fieldValue={lead.name}
                    style={{
                      margin: "0",
                      backgroundColor: "transparent",
                      color: "green",
                      border: "none",
                      width: "1%",
                      fontSize: ".6vw",
                      padding: "5px 5px",
                    }}
                    onClick={handleEditModeName}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <button
                    className="loginButtonLogin"
                    id={"name"}
                    value={lead.id}
                    style={{
                      margin: "0",
                      backgroundColor: "transparent",
                      color: "green",
                      border: "none",
                      width: "1%",
                      fontSize: ".6vw",
                      padding: "5px 5px",
                    }}
                    onClick={showLeadDetailBox}
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                  <button
                    className="loginButtonLogin"
                    id={"name"}
                    value={lead.id}
                    style={{
                      margin: "0",
                      backgroundColor: "transparent",
                      color: "green",
                      border: "none",
                      width: "10%",
                      fontSize: ".6vw",
                      padding: "5px 5px",
                    }}
                    onClick={showNoteSourceBox}
                  >
                    <FontAwesomeIcon icon={faFile} />
                  </button>
                </div>
              </div>
              <div style={{ width: "8%", textAlign: "left", padding: ".5%" }}>
                <p style={{ fontWeight: "600", margin: "0", fontSize: ".7vw" }}>
                  Numer telefonu:
                </p>{" "}
                <div style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
                  <span style={{ width: "100%", minHeight: ".8vw" }}>
                    {editModePhone && +editPhoneId === +lead.id ? (
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "80%" }}>
                          <input
                            type="text"
                            style={{
                              width: "100%",
                              height: "100%",
                              padding: "0px 10px",
                              boxSizing: "border-box",
                              fontSize: ".8vw",
                            }}
                            value={editPhone}
                            onChange={(e) => {
                              setEditPhone(e.target.value);
                            }}
                          />
                        </div>
                        <div style={{ width: "20%" }}>
                          <button
                            className="loginButtonLogin"
                            id={"phone"}
                            value={lead.id}
                            fieldValue={editPhone}
                            style={{
                              margin: "0",
                              backgroundColor: "transparent",
                              color: "green",
                              border: "none",
                              width: "1%",
                              fontSize: ".6vw",
                              padding: "5px 5px",
                            }}
                            onClick={editLeadField}
                          >
                            <FontAwesomeIcon icon={faSave} />
                          </button>
                        </div>
                      </div>
                    ) : (
                      lead.phone
                    )}
                  </span>
                  <button
                    className="loginButtonLogin"
                    id={"phone"}
                    value={lead.id}
                    fieldValue={editPhone}
                    style={{
                      margin: "0",
                      backgroundColor: "transparent",
                      color: "green",
                      border: "none",
                      width: "1%",
                      fontSize: ".6vw",
                      padding: "5px 5px",
                    }}
                    onClick={handleEditModePhone}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
              <div style={{ width: "14%", textAlign: "left", padding: ".5%" }}>
                <p style={{ fontWeight: "600", margin: "0", fontSize: ".7vw" }}>
                  Adres e-mail:
                </p>
                <div style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
                  <span
                    style={{
                      width: "100%",
                      minHeight: ".8vw",
                      lineBreak: "anywhere",
                    }}
                  >
                    {editModeMail && +editMailId === +lead.id ? (
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "80%" }}>
                          <input
                            type="text"
                            style={{
                              width: "100%",
                              height: "100%",
                              padding: "0px 10px",
                              boxSizing: "border-box",
                              fontSize: ".8vw",
                            }}
                            value={editMail}
                            onChange={(e) => {
                              setEditMail(e.target.value);
                            }}
                          />
                        </div>
                        <div style={{ width: "20%" }}>
                          <button
                            className="loginButtonLogin"
                            id={"mail"}
                            value={lead.id}
                            fieldValue={editMail}
                            style={{
                              margin: "0",
                              backgroundColor: "transparent",
                              color: "green",
                              border: "none",
                              width: "1%",
                              fontSize: ".6vw",
                              padding: "5px 5px",
                            }}
                            onClick={editLeadField}
                          >
                            <FontAwesomeIcon icon={faSave} />
                          </button>
                        </div>
                      </div>
                    ) : (
                      lead.mail
                    )}
                  </span>
                  <button
                    className="loginButtonLogin"
                    id={"mail"}
                    value={lead.id}
                    fieldValue={lead.mail}
                    style={{
                      margin: "0",
                      backgroundColor: "transparent",
                      color: "green",
                      border: "none",
                      width: "1%",
                      fontSize: ".6vw",
                      padding: "5px 5px",
                    }}
                    onClick={handleEditModeMail}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
              <div style={{ width: "15%", textAlign: "left", padding: ".5%" }}>
                <p style={{ fontWeight: "600", margin: "0", fontSize: ".7vw" }}>
                  Notatka:
                </p>
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    flexWrap: "wrap",
                    justifyContent: "left",
                  }}
                >
                  {editModeNote && +editNoteId === +lead.id ? (
                    <div style={{ display: "flex", width: "100%" }}>
                      <div style={{ width: "80%" }}>
                        <textarea
                          type="text"
                          style={{
                            width: "100%",
                            height: "100%",
                            padding: "0px 10px",
                            boxSizing: "border-box",
                            fontSize: ".8vw",
                            minHeight: "3vh",
                          }}
                          value={editNote}
                          onChange={(e) => {
                            setEditNote(e.target.value);
                          }}
                        />
                      </div>
                      <div style={{ width: "20%" }}>
                        <button
                          className="loginButtonLogin"
                          id={"statusNote"}
                          value={lead.id}
                          fieldValue={editNote}
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "1%",
                            fontSize: ".6vw",
                            padding: "5px 5px",
                          }}
                          onClick={editLeadField}
                        >
                          <FontAwesomeIcon icon={faSave} />
                        </button>
                      </div>
                    </div>
                  ) : (
                    <span
                      style={{
                        lineBreak: "anywhere",
                        fontSize: "1vw",
                        width: "100%",
                        minHeight: ".8vw",
                      }}
                    >
                      {showNote && +showNoteId === +lead.id
                        ? lead.statusNote
                        : lead.statusNote.substring(0, 50) + "..."}
                    </span>
                  )}

                  <button
                    className="loginButtonLogin"
                    id={"statusNote"}
                    value={lead.id}
                    fieldValue={lead.statusNote}
                    style={{
                      margin: "0",
                      backgroundColor: "transparent",
                      color: "green",
                      border: "none",
                      width: "1%",
                      fontSize: ".6vw",
                      padding: "5px 5px",
                    }}
                    onClick={handleShowNote}
                  >
                    <FontAwesomeIcon
                      icon={
                        showNote && +showNoteId === +lead.id
                          ? faEyeSlash
                          : faEye
                      }
                    />
                  </button>
                  <button
                    className="loginButtonLogin"
                    id={"statusNote"}
                    value={lead.id}
                    fieldValue={lead.statusNote}
                    style={{
                      margin: "0",
                      backgroundColor: "transparent",
                      color: "green",
                      border: "none",
                      width: "1%",
                      fontSize: ".6vw",
                      padding: "5px 5px",
                    }}
                    onClick={handleEditModeNote}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
              <div style={{ width: "10%", textAlign: "left", padding: ".5%" }}>
                <p
                  style={{
                    fontWeight: "600",
                    margin: "0",
                    fontSize: ".7vw",
                  }}
                >
                  Źródło:
                </p>
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    flexWrap: "wrap",
                    justifyContent: "left",
                  }}
                >
                  <span
                    style={{
                      lineBreak: "anywhere",
                      width: "100%",
                    }}
                  >
                    {lead.source}
                  </span>
                </div>
              </div>
              <div style={{ width: "10%", textAlign: "left", padding: ".5%" }}>
                <p style={{ fontWeight: "600", margin: "0", fontSize: ".7vw" }}>
                  Kontakty:
                </p>
                <div
                  style={{ display: "flex", padding: "10px 0px", gap: "5px" }}
                >
                  <button
                    className="loginButtonLogin"
                    id={"lastTalkDate"}
                    value={lead.id}
                    fieldValue={lead.lastTalkDate ? lead.lastTalkDate : ""}
                    style={{
                      margin: "0",
                      backgroundColor: "red",
                      color: "white",
                      border: "0px solid black",
                      width: "50%",
                      fontSize: ".5vw",
                      padding: "2px 5px",
                    }}
                    onClick={async () => {
                      var body = {
                        type: "off",
                        leadId: lead.id,
                        user: props.user.name,
                      };
                      await fetch(
                        "https://apisellcrm.ftpeople.pl/addLogPhone",
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: secretKey,
                          },
                          body: JSON.stringify(body),
                        }
                      )
                        .then((response) => response.text())
                        .then((data) => {
                          MySwal.fire({
                            icon: "success",
                            title: "Dodano",
                            text: "kontakt",
                          }).then(async (result) => {
                            getData();
                          });
                        })
                        .catch((error) => {});
                    }}
                  >
                    {"nieodebrany"}
                  </button>
                  <button
                    className="loginButtonLogin"
                    id={"lastTalkDate"}
                    value={lead.id}
                    fieldValue={lead.lastTalkDate ? lead.lastTalkDate : ""}
                    style={{
                      margin: "0",
                      backgroundColor: "green",
                      color: "white",
                      border: "0px solid black",
                      width: "50%",
                      fontSize: ".5vw",
                      padding: "2px 5px",
                    }}
                    onClick={async () => {
                      var body = {
                        type: "on",
                        leadId: lead.id,
                        user: props.user.name,
                      };
                      await fetch(
                        "https://apisellcrm.ftpeople.pl/addLogPhone",
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: secretKey,
                          },
                          body: JSON.stringify(body),
                        }
                      )
                        .then((response) => response.text())
                        .then((data) => {
                          MySwal.fire({
                            icon: "success",
                            title: "Dodano",
                            text: "kontakt",
                          }).then(async (result) => {
                            getData();
                          });
                        })
                        .catch((error) => {});
                    }}
                  >
                    {"odebrany"}
                  </button>
                </div>
                <div>
                  <p style={{ fontSize: ".6vw", margin: 0 }}>
                    odebrane:{" "}
                    {clikcs.filter((el) => +el.leadId === lead.id).length > 0
                      ? clikcs.filter((el) => +el.leadId === lead.id)[0].phoneOn
                      : 0}
                  </p>
                  <p style={{ fontSize: ".6vw", margin: 0 }}>
                    nieodebrane:{" "}
                    {clikcs.filter((el) => +el.leadId === lead.id).length > 0
                      ? clikcs.filter((el) => +el.leadId === lead.id)[0]
                          .phoneOff
                      : 0}
                  </p>
                </div>
              </div>
              <div style={{ width: "8%", textAlign: "left", padding: ".5%" }}>
                <p style={{ fontWeight: "600", margin: "0", fontSize: ".7vw" }}>
                  Data ostatniej rozmowy:
                </p>
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    flexWrap: "wrap",
                    justifyContent: "left",
                  }}
                >
                  <span
                    style={{
                      lineBreak: "anywhere",
                      width: "100%",
                    }}
                  >
                    {lead.lastTalkDate ? lead.lastTalkDate : "brak danych"}
                  </span>
                  <button
                    className="loginButtonLogin"
                    id={"lastTalkDate"}
                    value={lead.id}
                    fieldValue={lead.lastTalkDate ? lead.lastTalkDate : ""}
                    style={{
                      margin: "0",
                      backgroundColor: "transparent",
                      color: "green",
                      border: "none",
                      width: "1%",
                      fontSize: ".6vw",
                      padding: "5px 5px",
                    }}
                    onClick={editLeadDate}
                  >
                    <FontAwesomeIcon icon={faCheck} />
                  </button>
                </div>
              </div>
              <div
                style={{
                  width: "7%",
                  textAlign: "left",
                  padding: ".5%",
                }}
              >
                <p
                  style={{
                    fontWeight: "600",
                    margin: "0",
                    fontSize: ".7vw",
                  }}
                >
                  Status:
                </p>
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    flexWrap: "wrap",
                    justifyContent: "left",
                  }}
                >
                  <span
                    style={{
                      lineBreak: "anywhere",
                      width: "100%",
                      fontSize: ".8vw",
                    }}
                  >
                    {lead.status}
                  </span>
                  <button
                    className="loginButtonLogin"
                    id={"status"}
                    value={lead.id}
                    style={{
                      margin: "0",
                      backgroundColor: "transparent",
                      color: "green",
                      border: "none",
                      width: "1%",
                      fontSize: ".6vw",
                      padding: "5px 5px",
                    }}
                    onClick={editLeadStatus}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
              <div style={{ width: "3%", textAlign: "left", padding: ".5%" }}>
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    flexWrap: "wrap",
                    justifyContent: "left",
                  }}
                >
                  <button
                    className="loginButtonLogin"
                    id={"lastTalkDate"}
                    value={lead.id}
                    fieldValue={lead.lastTalkDate ? lead.lastTalkDate : ""}
                    style={{
                      margin: "0",
                      backgroundColor: "transparent",
                      color: "black",
                      border: "1px solid black",
                      width: "100%",
                      fontSize: ".5vw",
                      padding: "2px 5px",
                    }}
                    onClick={expandLead}
                  >
                    {+expandId === +lead.id ? "zwiń" : "rozwiń"}
                  </button>
                </div>
              </div>

              <div
                style={{
                  display: +expandId === +lead.id ? "block" : "none",
                  width: "100%",
                }}
              >
                <hr
                  style={{
                    width: "100%",
                    border: "none",
                    borderTop: "1px solid lightgray",
                  }}
                ></hr>
                <div style={{ display: "flex" }}>
                  <div
                    style={{ width: "12%", textAlign: "left", padding: ".5%" }}
                  >
                    <p
                      style={{
                        fontWeight: "600",
                        margin: "0",
                        fontSize: ".7vw",
                      }}
                    >
                      Data pozyskania:
                    </p>
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        flexWrap: "wrap",
                        justifyContent: "left",
                      }}
                    >
                      <span
                        style={{
                          lineBreak: "anywhere",
                          width: "100%",
                        }}
                      >
                        {new Date(lead.date).getFullYear() +
                          "-" +
                          (new Date(lead.date).getMonth() + 1 < 10
                            ? "0" + (new Date(lead.date).getMonth() + 1)
                            : new Date(lead.date).getMonth() + 1) +
                          "-" +
                          (new Date(lead.date).getDate() < 10
                            ? "0" + new Date(lead.date).getDate()
                            : new Date(lead.date).getDate())}
                      </span>
                    </div>
                  </div>
                  {props.user.role === "admin" ? (
                    <>
                      <div
                        style={{
                          width: "12%",
                          textAlign: "left",
                          padding: ".5%",
                        }}
                      >
                        <p
                          style={{
                            fontWeight: "600",
                            margin: "0",
                            fontSize: ".7vw",
                          }}
                        >
                          Handlowiec:
                        </p>
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            flexWrap: "wrap",
                            justifyContent: "left",
                          }}
                        >
                          <span
                            style={{
                              lineBreak: "anywhere",
                              width: "100%",
                              fontSize: ".8vw",
                            }}
                          >
                            {lead.sellerN ? lead.sellerN : "nie przypisano"}
                          </span>
                          <button
                            className="loginButtonLogin"
                            id={"seller"}
                            value={lead.id}
                            fieldValue={lead.company}
                            style={{
                              margin: "0",
                              backgroundColor: "transparent",
                              color: "green",
                              border: "none",
                              width: "1%",
                              fontSize: ".6vw",
                              padding: "5px 5px",
                            }}
                            onClick={editLeadSeller}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <div
                    style={{
                      width: "12%",
                      textAlign: "left",
                      padding: ".5%",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "600",
                        margin: "0",
                        fontSize: ".7vw",
                      }}
                    >
                      Wyślij SMS i MAIL po rozmowie:
                    </p>
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        flexWrap: "wrap",
                        justifyContent: "left",
                      }}
                    >
                      <button
                        className="loginButtonLogin"
                        id={"lastTalkDate"}
                        value={lead.id}
                        fieldValue={lead.company}
                        style={{
                          margin: "0",
                          backgroundColor: "transparent",
                          color: "black",
                          border: "1px solid black",
                          width: "100%",
                          fontSize: ".5vw",
                          padding: "2px 5px",
                        }}
                        onClick={sendLeadSMSMAIL_after}
                      >
                        WYŚLIJ
                      </button>
                    </div>
                  </div>
                  {props.user.role === "admin" && +lead.sendTemp !== 1 ? (
                    <div
                      style={{
                        width: "12%",
                        textAlign: "left",
                        padding: ".5%",
                      }}
                    >
                      <p
                        style={{
                          fontWeight: "600",
                          margin: "0",
                          fontSize: ".7vw",
                        }}
                      >
                        Przekaż do wysyłki do klienta
                      </p>
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                          flexWrap: "wrap",
                          justifyContent: "left",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"lastTalkDate"}
                          value={lead.id}
                          style={{
                            margin: "0",
                            backgroundColor: "green",
                            color: "white",
                            border: "1px solid green",
                            width: "100%",
                            fontSize: ".5vw",
                            padding: "2px 5px",
                          }}
                          onClick={sendLeadToSendTemp}
                        >
                          PRZEKAŻ
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {+lead.sendDone === 1 ? (
                    <div
                      style={{
                        width: "12%",
                        textAlign: "left",
                        padding: ".5%",
                      }}
                    >
                      <p
                        style={{
                          fontWeight: "600",
                          margin: "0",
                          fontSize: ".7vw",
                        }}
                      >
                        wysyłka została zrealizowana
                      </p>
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                          flexWrap: "wrap",
                          justifyContent: "left",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"lastTalkDate"}
                          value={lead.id}
                          fieldValue={lead.company}
                          style={{
                            margin: "0",
                            backgroundColor: "orange",
                            color: "white",
                            border: "1px solid orange",
                            width: "100%",
                            fontSize: ".5vw",
                            padding: "2px 5px",
                          }}
                          onClick={(e) => {
                            setShowSendReport(true);
                            setShowSendReportId(e.target.value);
                          }}
                        >
                          SZCZEGÓŁY
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </>
        ))}
      </div>
    </>
  );

  const createExcelDS = () => {
    var tab = [];
    leads.map((el) => {
      tab.push([
        el.id,
        el.name,
        el.phone,
        el.mail,
        el.status,
        el.source,
        el.sourceNote,
        el.date,
        el.statusNote,
        usersFull.filter((x) => +x.id === +el.seller)[0].name,
        el.company,
        el.sourceLink,
      ]);
    });
    return tab;
  };

  const exportToExcel = (e) => {
    var header = [
      "ID",
      "Imię i nazwisko",
      "Numer telefonu",
      "Adres e-mail",
      "Status",
      "Źródło",
      "Notatka - źródło",
      "Data pozyskania",
      "Notatka",
      "Handlowiec",
      "Dział",
      "LINK źródło",
    ];
    downloadExcel({
      fileName: "leads_report_" + new Date(),
      sheet: "data",
      tablePayload: {
        header,
        body: createExcelDS(),
      },
    });
  };

  const clearFilters = (e) => {
    setPage(1);
    setFilterText("");
    setFilterStatus([]);
    setSelectedOptionsStatus([]);
    setFilterSource([]);
    setSelectedOptionsSource([]);
    setFilterUser([]);
    setSelectedOptionsUser([]);
    setFilterCompany([]);
    setSelectedOptionsCompany([]);
    setFilterDateFrom("");
    setFilterDateTo("");
    setFilterDate(false);
    setFilterDateTalkFrom("");
    setFilterDateTalkTo("");
    setFilterDateTalk(false);
    setFilterDateStatus(false);
    setFilterDateStatusFrom("");
    setFilterDateStatusTo("");
    setSort("dateDesc");
    setLeads(
      leadsOri.sort(function (a, b) {
        return +a.statusPoz - +b.statusPoz;
      })
    );
  };

  const getStatusOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszystkie", value: "all" });

    leads.map((el) => {
      if (arr.filter((l) => l.label === el.status).length === 0) {
        var opt = { label: el.status, value: el.status };
        arr.push(opt);
      }
    });

    return arr;
  };

  const getSourceOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszystkie", value: "all" });

    leads.map((el) => {
      if (arr.filter((l) => l.label === el.source).length === 0) {
        var opt = { label: el.source, value: el.source };
        arr.push(opt);
      }
    });

    return arr;
  };

  const getUserOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszystkie", value: "all" });
    if (usersFull.length > 0) {
      var arr3 = [];
      leadsOri.map((l) => {
        if (arr3.filter((a) => +a === +l.seller).length === 0) {
          arr3.push(l.seller);
        }
      });
      var arr2 = [];
      arr3.map((a2) => {
        if (a2) {
          var obj = {
            id: a2,
            name: usersFull.filter((u2) => +u2.id === +a2)[0].name,
          };
          arr2.push(obj);
        }
      });

      arr2.map((el) => {
        var opt = { label: el.name, value: el.id };
        arr.push(opt);
      });
    }

    return arr;
  };

  const getCompanyOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszystkie", value: "all" });

    companies.map((el) => {
      var opt = { label: el.name, value: el.name };
      arr.push(opt);
    });

    return arr;
  };

  const checkOption = (arr, value) => {
    if (arr.filter((el) => el === value).length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const checkOptionNum = (arr, value) => {
    if (arr.filter((el) => +el === +value).length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleFilterChange = (value, mode, data) => {
    var arr = data;

    var fText = mode === "filterText" ? value : filterText;
    if (filterText.length > 0 || mode === "filterText") {
      arr = arr.filter(
        (el) =>
          el.name.includes(fText) ||
          el.phone.includes(fText) ||
          el.mail.includes(fText)
      );
    }

    var fStatus = mode === "filterStatus" ? value : filterStatus;
    if (filterStatus.length > 0 || mode === "filterStatus") {
      arr = arr.filter((el) => checkOption(fStatus, el.status));
    }

    var fSource = mode === "filterSource" ? value : filterSource;
    if (filterSource.length > 0 || mode === "filterSource") {
      arr = arr.filter((el) => checkOption(fSource, el.source));
    }

    var fUser = mode === "filterUser" ? value : filterUser;
    if (filterUser.length > 0 || mode === "filterUser") {
      arr = arr.filter((el) => checkOptionNum(fUser, el.seller));
    }

    var fCompany = mode === "filterCompany" ? value : filterCompany;
    if (filterCompany.length > 0 || mode === "filterCompany") {
      arr = arr.filter((el) => checkOption(fCompany, el.company));
    }

    var fDate = mode === "filterDate" ? value : filterDate;
    if (fDate) {
      console.log("date");

      console.log(
        new Date(
          new Date(filterDateTo).getFullYear() +
            "-" +
            (new Date(filterDateTo).getMonth() + 1) +
            "-" +
            new Date(filterDateTo).getDate()
        )
      );

      console.log(
        new Date(
          new Date(filterDateFrom).getFullYear() +
            "-" +
            (new Date(filterDateFrom).getMonth() + 1) +
            "-" +
            new Date(filterDateFrom).getDate()
        )
      );

      arr
        .filter((ex) => ex.date.includes("2025"))
        .map((el) => {
          console.log(
            new Date(
              new Date(el.date).getFullYear() +
                "-" +
                (new Date(el.date).getMonth() + 1) +
                "-" +
                new Date(el.date).getDate()
            )
          );
        });
      console.log(arr);

      arr = arr.filter(
        (el) =>
          new Date(
            new Date(el.date).getFullYear() +
              "-" +
              (new Date(el.date).getMonth() + 1) +
              "-" +
              new Date(el.date).getDate()
          ) >=
            new Date(
              new Date(filterDateFrom).getFullYear() +
                "-" +
                (new Date(filterDateFrom).getMonth() + 1) +
                "-" +
                new Date(filterDateFrom).getDate()
            ) &&
          new Date(
            new Date(el.date).getFullYear() +
              "-" +
              (new Date(el.date).getMonth() + 1) +
              "-" +
              new Date(el.date).getDate()
          ) <=
            new Date(
              new Date(filterDateTo).getFullYear() +
                "-" +
                (new Date(filterDateTo).getMonth() + 1) +
                "-" +
                new Date(filterDateTo).getDate()
            )
      );

      console.log(arr);
    }

    var fDate1 = mode === "filterDateTalk" ? value : filterDateTalk;
    if (fDate1) {
      console.log(arr);
      try {
        arr = arr.filter(
          (el) =>
            new Date(
              new Date(el.lastTalkDate).getFullYear() +
                "-" +
                (new Date(el.lastTalkDate).getMonth() + 1) +
                "-" +
                new Date(el.lastTalkDate).getDate()
            ) >=
              new Date(
                new Date(filterDateTalkFrom).getFullYear() +
                  "-" +
                  (new Date(filterDateTalkFrom).getMonth() + 1) +
                  "-" +
                  new Date(filterDateTalkFrom).getDate()
              ) &&
            new Date(
              new Date(el.lastTalkDate).getFullYear() +
                "-" +
                (new Date(el.lastTalkDate).getMonth() + 1) +
                "-" +
                new Date(el.lastTalkDate).getDate()
            ) <=
              new Date(
                new Date(filterDateTalkTo).getFullYear() +
                  "-" +
                  (new Date(filterDateTalkTo).getMonth() + 1) +
                  "-" +
                  new Date(filterDateTalkTo).getDate()
              )
        );
      } catch (err) {
        console.log(err);
      }

      console.log(arr);
    }

    var fDate1 = mode === "filterDateStatus" ? value : filterDateStatus;
    if (fDate1) {
      console.log(arr);
      try {
        arr = arr.filter(
          (el) =>
            el.dateChangeStatus !== "NULL" &&
            new Date(
              new Date(el.dateChangeStatus).getFullYear() +
                "-" +
                (new Date(el.dateChangeStatus).getMonth() + 1) +
                "-" +
                new Date(el.dateChangeStatus).getDate()
            ) >=
              new Date(
                new Date(filterDateStatusFrom).getFullYear() +
                  "-" +
                  (new Date(filterDateStatusFrom).getMonth() + 1) +
                  "-" +
                  new Date(filterDateStatusFrom).getDate()
              ) &&
            new Date(
              new Date(el.dateChangeStatus).getFullYear() +
                "-" +
                (new Date(el.dateChangeStatus).getMonth() + 1) +
                "-" +
                new Date(el.dateChangeStatus).getDate()
            ) <=
              new Date(
                new Date(filterDateStatusTo).getFullYear() +
                  "-" +
                  (new Date(filterDateStatusTo).getMonth() + 1) +
                  "-" +
                  new Date(filterDateStatusTo).getDate()
              )
        );
      } catch (err) {
        console.log(err);
      }

      console.log(arr);
    }

    setLeads(arr);
    //handleSortChange(sort, arr);
  };

  const handleChangeFilterText = (e) => {
    setPage(1);
    setFilterText(e.target.value);
    handleFilterChange(e.target.value, "filterText", leadsOri);
  };

  const handleChangeFilterStatus = (e) => {
    setPage(1);
    setFilterStatus(e);
    handleFilterChange(e, "filterStatus", leadsOri);
  };

  const handleChangeFilterUser = (e) => {
    setPage(1);
    setFilterUser(e);
    handleFilterChange(e, "filterUser", leadsOri);
  };

  const handleChangeFilterSource = (e) => {
    setPage(1);
    setFilterSource(e);
    handleFilterChange(e, "filterSource", leadsOri);
  };

  const handleChangeFilterCompany = (e) => {
    setPage(1);
    setFilterCompany(e);
    handleFilterChange(e, "filterCompany", leadsOri);
  };

  const closeAllHovering = (e) => {
    if (
      e.target.id !== "status" &&
      e.target.id !== "source" &&
      e.target.id !== "user" &&
      e.target.id !== "company"
    ) {
      setIsHoveringStatus(false);
      setIsHoveringSource(false);
      setIsHoveringUser(false);
      setIsHoveringCompany(false);
    }
  };

  const handleChangeFilterDateFrom = (e) => {
    setFilterDateFrom(e.target.value);
  };

  const handleChangeFilterDateTo = (e) => {
    setFilterDateTo(e.target.value);
  };

  const handleChangeFilterDate = (e) => {
    if (new Date(e.target.value) < new Date(filterDateFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data do",
        text: 'nie może być mniejsza niż "Data od"',
      });
      return;
    }
    if (new Date(e.target.value) > new Date(filterDateTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    if (filterDateFrom && filterDateTo) {
      setPage(1);
      setFilterDate(true);
      handleFilterChange(true, "filterDate", leadsOri);
    }
  };

  const handleChangeFilterDateTalkFrom = (e) => {
    setFilterDateTalkFrom(e.target.value);
  };

  const handleChangeFilterDateTalkTo = (e) => {
    setFilterDateTalkTo(e.target.value);
  };

  const handleChangeFilterDateTalk = (e) => {
    if (new Date(e.target.value) < new Date(filterDateTalkFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data do",
        text: 'nie może być mniejsza niż "Data od"',
      });
      return;
    }
    if (new Date(e.target.value) > new Date(filterDateTalkTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    if (filterDateTalkFrom && filterDateTalkTo) {
      setPage(1);
      setFilterDateTalk(true);
      handleFilterChange(true, "filterDateTalk", leadsOri);
    }
  };

  const handleChangeFilterDateStatusFrom = (e) => {
    setFilterDateStatusFrom(e.target.value);
  };

  const handleChangeFilterDateStatusTo = (e) => {
    setFilterDateStatusTo(e.target.value);
  };

  const handleChangeFilterDateStatus = (e) => {
    if (new Date(e.target.value) < new Date(filterDateStatusFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data do",
        text: 'nie może być mniejsza niż "Data od"',
      });
      return;
    }
    if (new Date(e.target.value) > new Date(filterDateStatusTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    if (filterDateStatusFrom && filterDateStatusTo) {
      setPage(1);
      setFilterDateStatus(true);
      handleFilterChange(true, "filterDateStatus", leadsOri);
    }
  };

  const handleSortChange = (mode, data) => {
    if (mode === "") {
      return;
    }

    if (mode === "dateAsc") {
      setLeads(
        data.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date);
        })
      );
    } else if (mode === "dateDesc") {
      setLeads(
        data.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        })
      );
    }
  };

  const handleSortDataChange = (e) => {
    setSort(e.target.value);
    handleSortChange(e.target.value, leads);
  };

  const handleAddPage = () => {
    if (+page * +perPage < leads.length) {
      setPage(+page + 1);
    }
  };

  const handleSubPage = () => {
    if (+page > 1) {
      setPage(+page - 1);
    }
  };

  return (
    <>
      <div onClick={closeAllHovering}>
        {loading ? (
          <Loading />
        ) : (
          <>
            {chooseLeadsFlag ? (
              <>
                <div
                  className="progressBox"
                  style={{
                    width: "5vw",
                    height: "5vh",
                    borderBottomLeftRadius: "5px",
                    borderTopLeftRadius: "5px",
                    padding: "5px",
                    backgroundColor: "orange",
                    color: "white",
                    position: "fixed",
                    right: "0",
                    top: "25vh",
                    zIndex: "2",
                    bottom: "0",
                    textAlign: "center",
                    cursor: "pointer",
                    textTransform: "uppercase",
                    lineHeight: "2vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => {
                    var model = [];
                    statuses.map((el) => {
                      model[el.name] = el.name;
                    });

                    MySwal.fire({
                      title: "Wybierz wartość",
                      input: "select",
                      inputOptions: model,
                      inputPlaceholder: "wybierz wartość",
                      showCancelButton: true,
                      cancelButtonText: "Anuluj",
                      inputValidator: function (value) {
                        return new Promise(function (resolve, reject) {
                          if (value !== "") {
                            resolve();
                          } else {
                            resolve("musisz wybrać wartość");
                          }
                        });
                      },
                    }).then(async function (result) {
                      if (result.isConfirmed) {
                        var body = {
                          leads: JSON.stringify(chooseLeads),
                          status: result.value,
                        };
                        console.log(body);

                        await fetch(
                          "https://apisellcrm.ftpeople.pl/editLeadStatusGroup",
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: secretKey,
                            },
                            body: JSON.stringify(body),
                          }
                        )
                          .then((response) => response.text())
                          .then((data) => {
                            console.log(data);
                            setChooseLeads([]);
                            setChooseLeadsFlag(false);
                            setLoading(true);
                            getData();
                          })
                          .catch((error) => {});
                      }
                    });
                  }}
                >
                  <span
                    style={{
                      fontSize: "1vw",
                      fontWeight: "600",
                      animation: "pulse 1s infinite",
                    }}
                  >
                    ZMIEŃ STATUS
                  </span>
                </div>
                <div
                  className="progressBox"
                  style={{
                    width: "5vw",
                    height: "5vh",
                    borderBottomLeftRadius: "5px",
                    borderTopLeftRadius: "5px",
                    padding: "5px",
                    backgroundColor: "GREEN",
                    color: "white",
                    position: "fixed",
                    right: "0",
                    top: "35vh",
                    zIndex: "2",
                    bottom: "0",
                    textAlign: "center",
                    cursor: "pointer",
                    textTransform: "uppercase",
                    lineHeight: "2vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={async () => {
                    var body = {
                      leads: JSON.stringify(chooseLeads),
                    };
                    console.log(body);

                    await fetch(
                      "https://apisellcrm.ftpeople.pl/editLeadSendGroup",
                      {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body),
                      }
                    )
                      .then((response) => response.text())
                      .then((data) => {
                        console.log(data);
                        setChooseLeads([]);
                        setChooseLeadsFlag(false);
                        setLoading(true);
                        getData();
                      })
                      .catch((error) => {});
                  }}
                >
                  <span
                    style={{
                      fontSize: "1vw",
                      fontWeight: "600",
                      animation: "pulse 1s infinite",
                    }}
                  >
                    PRZEKAŻ DO WYSYŁKI
                  </span>
                </div>
              </>
            ) : (
              ""
            )}
            {showConf ? (
              <Conf
                close={() => {
                  setShowConf(!showConf);
                }}
                querySource={querySource}
                setQuerySource={setQuerySource}
                queryStatus={queryStatus}
                setQueryStatus={setQueryStatus}
                getData={getDataConf}
              />
            ) : (
              ""
            )}
            {showSendReport ? (
              <LeadSendDetail
                id={showSendReportId}
                close={() => {
                  setShowSendReportId("");
                  setShowSendReport(false);
                }}
              />
            ) : (
              ""
            )}
            {showStats ? (
              <Statistics
                close={() => {
                  setShowStats(!showStats);
                }}
                users={usersFull}
                leads={leadsOri}
              />
            ) : (
              ""
            )}
            {showAddContact ? (
              <>
                <AddContact
                  mode={"list"}
                  user={props.user}
                  leadId={addContactLeadId}
                  close={closeAddContact}
                />
              </>
            ) : (
              ""
            )}
            {showNoteB ? (
              <>
                <ShowNote
                  close={() => {
                    setShowNoteB(false);
                  }}
                  lead={leadDetail}
                  mode={noteMode}
                />
              </>
            ) : (
              ""
            )}
            {showCheckCon ? (
              <>
                <AddCon
                  con={con}
                  close={closeCheckCon}
                  lead={checkLead}
                  user={props.user}
                />
              </>
            ) : (
              ""
            )}

            {showLeadDetail ? (
              <>
                <LeadDetail
                  close={closeLeadDetail}
                  lead={leadDetail}
                  user={props.user}
                />
              </>
            ) : (
              <>
                <div
                  style={{
                    paddingBottom: "3vh",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "left",
                      gap: "1vw",
                      alignItems: "self-end",
                      position: "sticky",
                      flexWrap: "wrap",
                      top: "0",
                      zIndex: "1",
                      padding: "5px 5px",
                      backgroundColor: "white",
                      paddingLeft: "1vw",
                      width: "100%",
                      paddingBottom: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "self-end",
                        justifyContent: "left",
                        gap: "1vw",
                      }}
                    >
                      <button
                        className="loginButtonLogin"
                        value="yes"
                        style={{
                          margin: "0",
                          backgroundColor: "green",
                          borderColor: "green",
                          width: "180px",
                          height: "3vh",
                        }}
                        onClick={getData}
                      >
                        ODŚWIEŻ
                      </button>

                      {props.user.role === "admin" ? (
                        <button
                          className="loginButtonLogin"
                          value="yes"
                          style={{
                            margin: "0",
                            backgroundColor: "blue",
                            borderColor: "blue",
                            width: "180px",
                            height: "3vh",
                          }}
                          onClick={exportToExcel}
                        >
                          EKSPORT DO EXCEL
                        </button>
                      ) : (
                        ""
                      )}
                      <div style={{ width: "180px", textAlign: "left" }}>
                        <p
                          style={{
                            margin: "0",
                            marginBottom: "2px",
                            fontWeight: "600",
                            fontSize: ".6vw",
                            paddingLeft: "2px",
                          }}
                        >
                          nazwa, tel., mail
                        </p>
                        <input
                          type="text"
                          style={{
                            width: "100%",
                            padding: "0px 10px",
                            boxSizing: "border-box",
                            height: "3vh",
                          }}
                          value={filterText}
                          onChange={handleChangeFilterText}
                        />
                      </div>
                      <button
                        className="loginButtonLogin"
                        value="yes"
                        style={{
                          margin: "0",
                          backgroundColor: "gray",
                          borderColor: "gray",
                          width: "auto",
                          height: "3vh",
                        }}
                        onClick={() => {
                          setShowConf(!showConf);
                        }}
                      >
                        CONF.
                      </button>
                      <button
                        className="loginButtonLogin"
                        value="yes"
                        style={{
                          margin: "0",
                          backgroundColor: "cyan",
                          borderColor: "cyan",
                          color: "black",
                          width: "auto",
                          height: "3vh",
                        }}
                        onClick={() => {
                          setShowStats(!showStats);
                        }}
                      >
                        STATYSTYKI
                      </button>
                    </div>

                    <div
                      style={
                        showFilters
                          ? {
                              width: "100%",
                              display: "block",
                            }
                          : {
                              display: "none",
                            }
                      }
                    >
                      <p style={{ textAlign: "left", fontWeight: "600" }}>
                        FILTRY
                      </p>

                      <div
                        style={{
                          display: "flex",
                          gap: "5px 20px",
                          flexWrap: "wrap",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ width: "23%", textAlign: "left" }}>
                          <p
                            style={{
                              margin: "0",
                              marginBottom: "10px",
                              fontWeight: "600",
                              fontSize: ".6vw",
                              paddingLeft: "2px",
                            }}
                          >
                            status
                          </p>
                          <MultiSelect
                            options={getStatusOptions()}
                            value={filterStatus}
                            onChange={handleChangeFilterStatus}
                            selectedOptions={selectedOptionsStatus}
                            setSelectedOptions={setSelectedOptionsStatus}
                            isHovering={isHoveringStatus}
                            setIsHovering={setIsHoveringStatus}
                            id={"status"}
                            closeAllHovering={closeAllHovering}
                          />
                        </div>
                        <div style={{ width: "23%", textAlign: "left" }}>
                          <p
                            style={{
                              margin: "0",
                              marginBottom: "10px",
                              fontWeight: "600",
                              fontSize: ".6vw",
                              paddingLeft: "2px",
                            }}
                          >
                            źródło
                          </p>
                          <MultiSelect
                            options={getSourceOptions()}
                            value={filterSource}
                            onChange={handleChangeFilterSource}
                            selectedOptions={selectedOptionsSource}
                            setSelectedOptions={setSelectedOptionsSource}
                            isHovering={isHoveringSource}
                            setIsHovering={setIsHoveringSource}
                            id={"source"}
                            closeAllHovering={closeAllHovering}
                          />
                        </div>
                        {props.user.role === "admin" ? (
                          <>
                            <div style={{ width: "23%", textAlign: "left" }}>
                              <p
                                style={{
                                  margin: "0",
                                  marginBottom: "10px",
                                  fontWeight: "600",
                                  fontSize: ".6vw",
                                  paddingLeft: "2px",
                                }}
                              >
                                dział
                              </p>
                              <MultiSelect
                                options={getCompanyOptions()}
                                value={filterCompany}
                                onChange={handleChangeFilterCompany}
                                selectedOptions={selectedOptionsCompany}
                                setSelectedOptions={setSelectedOptionsCompany}
                                isHovering={isHoveringCompany}
                                setIsHovering={setIsHoveringCompany}
                                id={"company"}
                                closeAllHovering={closeAllHovering}
                              />
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        {props.user.role === "admin" ? (
                          <>
                            <div style={{ width: "23%", textAlign: "left" }}>
                              <p
                                style={{
                                  margin: "0",
                                  marginBottom: "10px",
                                  fontWeight: "600",
                                  fontSize: ".6vw",
                                  paddingLeft: "2px",
                                }}
                              >
                                handlowiec
                              </p>
                              <MultiSelect
                                options={getUserOptions()}
                                value={filterUser}
                                onChange={handleChangeFilterUser}
                                selectedOptions={selectedOptionsUser}
                                setSelectedOptions={setSelectedOptionsUser}
                                isHovering={isHoveringUser}
                                setIsHovering={setIsHoveringUser}
                                id={"user"}
                                closeAllHovering={closeAllHovering}
                              />
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        {props.user.role === "user" ? (
                          <>
                            <div style={{ width: "100%" }}></div>
                          </>
                        ) : (
                          ""
                        )}
                        <div style={{ display: "block" }}>
                          <div
                            style={{
                              marginBottom: "1vh",
                              width: "100%",
                              textAlign: "left",
                            }}
                          >
                            <label
                              style={{
                                fontSize: ".6vw",
                                fontWeight: "600",
                                paddingLeft: "5px",
                              }}
                            >
                              data pozyskania
                            </label>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                width: "100%",
                              }}
                              className="inputBox"
                            >
                              <div style={{ width: "45%" }}>
                                <label
                                  style={{
                                    fontSize: ".6vw",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  od
                                </label>
                                <input
                                  style={{ height: "3vh", width: "100%" }}
                                  type="date"
                                  id="name"
                                  name="name"
                                  value={filterDateFrom}
                                  onChange={handleChangeFilterDateFrom}
                                />
                              </div>
                              <div style={{ width: "45%" }}>
                                <label
                                  style={{
                                    fontSize: ".6vw",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  do
                                </label>
                                <input
                                  style={{ height: "3vh", width: "100%" }}
                                  type="date"
                                  id="name"
                                  name="name"
                                  value={filterDateTo}
                                  onChange={handleChangeFilterDateTo}
                                />
                              </div>
                            </div>
                            <div
                              style={{ marginTop: "10px", textAlign: "left" }}
                            >
                              <button
                                style={{
                                  backgroundColor: "navy",
                                  border: "none",
                                  color: "white",
                                  textTransform: "uppercase",
                                  fontWeight: "600",
                                  borderRadius: "5px",
                                }}
                                id="clientsFilterButton"
                                className="paymentMenuButton"
                                onClick={handleChangeFilterDate}
                              >
                                Zastosuj filtr daty
                              </button>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "block" }}>
                          <div
                            style={{
                              marginBottom: "1vh",
                              width: "100%",
                              textAlign: "left",
                            }}
                          >
                            <label
                              style={{
                                fontSize: ".6vw",
                                fontWeight: "600",
                                paddingLeft: "5px",
                              }}
                            >
                              data ostatniego kontaktu
                            </label>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                width: "100%",
                              }}
                              className="inputBox"
                            >
                              <div style={{ width: "45%" }}>
                                <label
                                  style={{
                                    fontSize: ".6vw",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  od
                                </label>
                                <input
                                  style={{ height: "3vh", width: "100%" }}
                                  type="date"
                                  id="name"
                                  name="name"
                                  value={filterDateTalkFrom}
                                  onChange={handleChangeFilterDateTalkFrom}
                                />
                              </div>
                              <div style={{ width: "45%" }}>
                                <label
                                  style={{
                                    fontSize: ".6vw",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  do
                                </label>
                                <input
                                  style={{ height: "3vh", width: "100%" }}
                                  type="date"
                                  id="name"
                                  name="name"
                                  value={filterDateTalkTo}
                                  onChange={handleChangeFilterDateTalkTo}
                                />
                              </div>
                            </div>
                            <div
                              style={{ marginTop: "10px", textAlign: "left" }}
                            >
                              <button
                                style={{
                                  backgroundColor: "navy",
                                  border: "none",
                                  color: "white",
                                  textTransform: "uppercase",
                                  fontWeight: "600",
                                  borderRadius: "5px",
                                }}
                                id="clientsFilterButton"
                                className="paymentMenuButton"
                                onClick={handleChangeFilterDateTalk}
                              >
                                Zastosuj filtr daty
                              </button>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "block" }}>
                          <div
                            style={{
                              marginBottom: "1vh",
                              width: "100%",
                              textAlign: "left",
                            }}
                          >
                            <label
                              style={{
                                fontSize: ".6vw",
                                fontWeight: "600",
                                paddingLeft: "5px",
                              }}
                            >
                              data zmiany statusu
                            </label>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                width: "100%",
                              }}
                              className="inputBox"
                            >
                              <div style={{ width: "45%" }}>
                                <label
                                  style={{
                                    fontSize: ".6vw",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  od
                                </label>
                                <input
                                  style={{ height: "3vh", width: "100%" }}
                                  type="date"
                                  id="name"
                                  name="name"
                                  value={filterDateStatusFrom}
                                  onChange={handleChangeFilterDateStatusFrom}
                                />
                              </div>
                              <div style={{ width: "45%" }}>
                                <label
                                  style={{
                                    fontSize: ".6vw",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  do
                                </label>
                                <input
                                  style={{ height: "3vh", width: "100%" }}
                                  type="date"
                                  id="name"
                                  name="name"
                                  value={filterDateStatusTo}
                                  onChange={handleChangeFilterDateStatusTo}
                                />
                              </div>
                            </div>
                            <div
                              style={{ marginTop: "10px", textAlign: "left" }}
                            >
                              <button
                                style={{
                                  backgroundColor: "navy",
                                  border: "none",
                                  color: "white",
                                  textTransform: "uppercase",
                                  fontWeight: "600",
                                  borderRadius: "5px",
                                }}
                                id="clientsFilterButton"
                                className="paymentMenuButton"
                                onClick={handleChangeFilterDateStatus}
                              >
                                Zastosuj filtr daty
                              </button>
                            </div>
                          </div>
                        </div>
                        <button
                          className="loginButtonLogin"
                          value="yes"
                          style={{
                            margin: "0",
                            backgroundColor: "green",
                            borderColor: "green",
                            width: "140px",
                            fontSize: ".6vw",
                            height: "3vh",
                          }}
                          onClick={clearFilters}
                        >
                          WYCZYŚĆ FILTRY
                        </button>
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <select
                          style={{ height: "3vh", width: "25%" }}
                          type="date"
                          id="name"
                          name="name"
                          value={sort}
                          onChange={handleSortDataChange}
                        >
                          {sort === "" ? (
                            <option key={2}>Wybierz sortowanie...</option>
                          ) : (
                            ""
                          )}
                          <option key={0} value="dateAsc">
                            Data pozyskania - od najstarszej
                          </option>
                          <option key={1} value="dateDesc">
                            Data pozyskania - od najmłodszej
                          </option>
                        </select>
                      </div>
                    </div>
                    <div style={{ marginTop: "-3vh" }}>
                      <button
                        className="loginButtonLogin"
                        onClick={() => {
                          setShowFilters(!showFilters);
                        }}
                        style={{
                          margin: "0",
                          backgroundColor: "orange",
                          borderColor: "orange",
                          width: "100px",
                          fontSize: ".6vw",
                          height: "2vh",
                          color: "white",
                          border: "none",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {showFilters ? "zwiń filtry" : "rozwiń filtry"}
                      </button>
                    </div>
                    <div
                      style={{
                        marginTop: "-3vh",
                        display: "flex",
                        gap: "15px",
                      }}
                    >
                      <span style={{ width: "130px" }}>
                        STR. {page}/{Math.ceil(leads.length / +perPage)}
                      </span>
                      <button
                        className="loginButtonLogin"
                        onClick={handleSubPage}
                        style={{
                          margin: "0",
                          backgroundColor: "orange",
                          borderColor: "orange",
                          fontSize: ".6vw",
                          width: "20px",
                          height: "2vh",
                          color: "white",
                          border: "none",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {"<"}
                      </button>
                      <button
                        className="loginButtonLogin"
                        onClick={handleAddPage}
                        style={{
                          margin: "0",
                          backgroundColor: "orange",
                          borderColor: "orange",
                          fontSize: ".6vw",
                          width: "20px",
                          height: "2vh",
                          color: "white",
                          border: "none",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {">"}
                      </button>
                    </div>
                  </div>
                  <div>{leadsData2}</div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Database;
